import React from 'react';
import { useAuth } from '../../authentication/authContext';
import { Form, Input, Button, Card, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './login.css';
import { ValidationRules } from '../../helpers/functions';
import { MethodType, useApi } from '../../helpers/apiClient';
import { LOCAL_STORAGE_KEYS, ROUTES } from '../../helpers/constants';
import { useNavigate } from 'react-router';

const { Title } = Typography;

function Login() {
    const { setUser } = useAuth();
    const { callApi, loading } = useApi();
    const navigate = useNavigate();


    const onFinish = async (values) => {
        const response = await callApi(MethodType.POST, '/admin/auth/login', values);
        if (!response) return;
        setUser({ isLoggedIn: true, data: response.data.user, isLoading: false });
        localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, response.data.token);
        navigate(ROUTES.USER_LIST);
    };

    return (
        <div className="login-container">
            <Card className="login-card">
                <Title level={2} className="login-title">Pinzpo Admin</Title>
                <Form
                    name="login_form"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Form.Item
                        name="email"
                        rules={[ValidationRules.email]}
                    >
                        <Input prefix={<UserOutlined />} placeholder="Email" size="large" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={ValidationRules.password}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" block size="large" loading={loading} disabled={loading}>
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}

export default Login